module.exports = __webpack_public_path__ + "static/img/1.54b90bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/1.png
// module id = M6fy
// module chunks = 0